/* tslint:disable */
/* eslint-disable */
/**
 * Web App core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Currency } from './Currency';
import {
    CurrencyFromJSON,
    CurrencyFromJSONTyped,
    CurrencyToJSON,
} from './Currency';

/**
 * 
 * @export
 * @interface PrepaidBalance
 */
export interface PrepaidBalance {
    /**
     * 
     * @type {string}
     * @memberof PrepaidBalance
     */
    readonly laundryUserId: string;
    /**
     * 
     * @type {string}
     * @memberof PrepaidBalance
     */
    readonly accountId?: string;
    /**
     * Prepaid Balance available minus authorized amount (balance - authorized)
     * @type {number}
     * @memberof PrepaidBalance
     */
    readonly balance: number;
    /**
     * 
     * @type {Currency}
     * @memberof PrepaidBalance
     */
    currency: Currency;
}

/**
 * Check if a given object implements the PrepaidBalance interface.
 */
export function instanceOfPrepaidBalance(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "laundryUserId" in value;
    isInstance = isInstance && "balance" in value;
    isInstance = isInstance && "currency" in value;

    return isInstance;
}

export function PrepaidBalanceFromJSON(json: any): PrepaidBalance {
    return PrepaidBalanceFromJSONTyped(json, false);
}

export function PrepaidBalanceFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrepaidBalance {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'laundryUserId': json['laundryUserId'],
        'accountId': !exists(json, 'accountId') ? undefined : json['accountId'],
        'balance': json['balance'],
        'currency': CurrencyFromJSON(json['currency']),
    };
}

export function PrepaidBalanceToJSON(value?: PrepaidBalance | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'currency': CurrencyToJSON(value.currency),
    };
}

